import styled from 'styled-components';
import { useState } from 'react';
import { WaringModal } from '../../modal/WaringModal';
import { mobileQuery } from '../../../utils';
import { ImageUtils } from '../../../utils/ImageUtils';

export const ActiveTicket = ({
  goMainEventTab,
  ticketCnt,
}: {
  goMainEventTab: () => void;
  ticketCnt: number;
}) => {
  const [showWarningModal, setShowWarningModal] = useState(false);

  return (
    <>
      <Container>
        <ImgContainer>
          <QuestionIcon onClick={() => setShowWarningModal(true)} />
          <TicketImg src={ImageUtils.ParticipateInfoActive} alt={'ParticipateInfoActive'} />
        </ImgContainer>
        <CountContainer>
          <CountCnt>
            {ticketCnt}
            <CountUnit>장</CountUnit>
          </CountCnt>
          <RemainContainer>
            <RemainText>남은 메인 이벤트 참가 티켓</RemainText>
          </RemainContainer>
          <RemainSubText>
            참가 티켓은 <span>12 TO 1</span> 방식으로 지급되며,
            <br />
            250장 모두 지급되면 새틀라이트가 조기종료 됩니다.
          </RemainSubText>

          <CongratsText>축하합니다!</CongratsText>
          <CongratsSubText>
            메인 이벤트 티켓을 획득했어요. <br />
            메인 이벤트 참가 안내를 확인해주세요!
          </CongratsSubText>
        </CountContainer>
      </Container>
      <BottomTabContainer>
        <GoMainEventBtn onClick={goMainEventTab}>메인이벤트 참가 안내 확인하기</GoMainEventBtn>
      </BottomTabContainer>
      <WaringModal visible={showWarningModal} close={() => setShowWarningModal(false)} />
    </>
  );
};

const ImgContainer = styled.div`
  position: relative;
`;

const TicketImg = styled.img`
  ${mobileQuery} {
    width: 350px;
  }
`;

const Container = styled.div`
  position: relative;
  padding-bottom: 180px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 720px) {
    padding-bottom: 130px;
  }
`;

const CountContainer = styled.div`
  position: absolute;
  top: 10px;
  width: 100%;
  text-align: center;
`;

const RemainContainer = styled.div`
  width: 400px;
  margin: 0 auto;
  margin-bottom: 9px;

  border-top: 1.5px solid rgba(0, 0, 0, 0.5);

  background: rgba(0, 0, 0, 0.1);
  height: 35px;

  ${mobileQuery} {
    padding-top: 2px;
    width: 200px;
    height: 29px;
  }
`;

const RemainText = styled.h3`
  font-weight: 800;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: -0.02em;

  color: rgba(0, 0, 0, 0.7);

  ${mobileQuery} {
    font-size: 16px;
    line-height: 22px;
  }
`;

const RemainSubText = styled.h4`
  font-size: 22px;
  line-height: 28px;
  letter-spacing: -0.03em;
  color: rgba(0, 0, 0, 0.5);
  font-weight: 500;

  span {
    font-weight: 800;
  }
  ${mobileQuery} {
    font-size: 14px;
    line-height: 20px;
  }
`;

const CongratsText = styled.h3`
  font-weight: 900;
  font-size: 48px;
  line-height: 52px;
  letter-spacing: -0.02em;

  color: #d2006d;
  margin-top: 50px;
  margin-bottom: 10px;

  ${mobileQuery} {
    margin-top: 30px;
    margin-bottom: 5px;
    font-size: 24px;
    line-height: 30px;
  }
`;

const CongratsSubText = styled.h4`
  font-weight: 600;
  font-size: 26px;
  line-height: 32px;
  letter-spacing: -0.02em;

  color: #840053;
  ${mobileQuery} {
    font-size: 13px;
    line-height: 17px;
  }
`;

const CountCnt = styled.p`
  font-size: 140px;
  line-height: 150px;
  font-weight: bold;

  ${mobileQuery} {
    font-size: 96px;
    line-height: 131px;
  }
`;

const CountUnit = styled.span`
  font-size: 96px;
  ${mobileQuery} {
    font-size: 24px;
    line-height: 32px;
  }
`;

const QuestionIcon = styled.div`
  position: absolute;
  width: 50px;
  height: 50px;
  right: 30px;
  top: 40px;
  cursor: pointer;
  z-index: 1;
  background-image: url(${ImageUtils.QuestionIcon});

  ${mobileQuery} {
    width: 25px;
    height: 25px;
    right: 10px;
    top: 20px;
    background-size: contain;
  }
`;

const BottomTabContainer = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 10;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
`;

const GoMainEventBtn = styled.button`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100%;
  left: 0;
  cursor: pointer;
  height: 70px;
  background-color: #b60058;

  font-weight: 900;
  font-size: 21px;
  line-height: 28px;
  letter-spacing: -0.04em;

  color: #ffffff;
`;
